"use client";

import { c as _c } from "react/compiler-runtime";
import { CreateWaveGroupConfigType, WaveGroupsConfig } from "@/types/waves.types";
import { CREATE_WAVE_NONE_GROUP_LABELS, CREATE_WAVE_SELECT_GROUP_LABELS } from "@/helpers/waves/waves.constants";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveToggle from "../utils/CreateWaveToggle";
import CreateWaveGroupSearchField from "./CreateWaveGroupSearchField";
export default function CreateWaveGroup(t0) {
  const $ = _c(29);
  const {
    waveType,
    groupType,
    chatEnabled,
    adminCanDeleteDrops,
    setChatEnabled,
    onGroupSelect,
    groupsCache,
    groups,
    setDropsAdminCanDelete
  } = t0;
  const getSelectedGroupId = () => {
    switch (groupType) {
      case CreateWaveGroupConfigType.ADMIN:
        {
          return groups.admin;
        }
      case CreateWaveGroupConfigType.CAN_VIEW:
        {
          return groups.canView;
        }
      case CreateWaveGroupConfigType.CAN_DROP:
        {
          return groups.canDrop;
        }
      case CreateWaveGroupConfigType.CAN_VOTE:
        {
          return groups.canVote;
        }
      case CreateWaveGroupConfigType.CAN_CHAT:
        {
          return groups.canChat;
        }
      default:
        {
          return null;
        }
    }
  };
  const selectedGroupId = getSelectedGroupId();
  const selectedGroup = selectedGroupId && groupsCache[selectedGroupId] ? groupsCache[selectedGroupId] : null;
  const isNotChatWave = waveType !== ApiWaveType.Chat;
  const inputDisabled = isNotChatWave && groupType === CreateWaveGroupConfigType.CAN_CHAT && !chatEnabled;
  const defaultLabel = CREATE_WAVE_NONE_GROUP_LABELS[groupType];
  const t1 = CREATE_WAVE_SELECT_GROUP_LABELS[waveType][groupType];
  let t2;
  if ($[0] !== t1) {
    t2 = <h3 className="tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50 tw-tracking-tight tw-mb-0">{t1}</h3>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== chatEnabled || $[3] !== groupType || $[4] !== isNotChatWave || $[5] !== setChatEnabled) {
    t3 = isNotChatWave && groupType === CreateWaveGroupConfigType.CAN_CHAT && <CreateWaveToggle enabled={chatEnabled} onChange={setChatEnabled} label="Enable chat" />;
    $[2] = chatEnabled;
    $[3] = groupType;
    $[4] = isNotChatWave;
    $[5] = setChatEnabled;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== adminCanDeleteDrops || $[8] !== groupType || $[9] !== isNotChatWave || $[10] !== setDropsAdminCanDelete) {
    t4 = isNotChatWave && groupType === CreateWaveGroupConfigType.ADMIN && <CreateWaveToggle enabled={adminCanDeleteDrops} onChange={setDropsAdminCanDelete} label="Allow admins to delete drops" displayLabel={true} />;
    $[7] = adminCanDeleteDrops;
    $[8] = groupType;
    $[9] = isNotChatWave;
    $[10] = setDropsAdminCanDelete;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">{t2}{t3}{t4}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== adminCanDeleteDrops || $[17] !== groupType || $[18] !== isNotChatWave) {
    t6 = isNotChatWave && groupType === CreateWaveGroupConfigType.ADMIN && adminCanDeleteDrops && <p className="tw-mt-2 tw-text-sm tw-text-iron-400">Admins will be able to delete drops after they've been submitted.</p>;
    $[16] = adminCanDeleteDrops;
    $[17] = groupType;
    $[18] = isNotChatWave;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== defaultLabel || $[21] !== inputDisabled || $[22] !== onGroupSelect || $[23] !== selectedGroup) {
    t7 = <CreateWaveGroupSearchField label={"Search groups\u2026"} defaultLabel={defaultLabel} disabled={inputDisabled} selectedGroup={selectedGroup} onSelect={onGroupSelect} />;
    $[20] = defaultLabel;
    $[21] = inputDisabled;
    $[22] = onGroupSelect;
    $[23] = selectedGroup;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t8 = <div className="tw-flex tw-flex-col tw-gap-y-4">{t5}{t6}{t7}</div>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
}